var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElIconEye = function SvgElIconEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E3D3D",
    d: "M21.908 10.633C21.725 10.267 17.875 2.75 11 2.75 4.125 2.75.275 10.267.092 10.633c-.092.275-.092.55 0 .825.183.275 4.033 7.792 10.908 7.792 6.875 0 10.725-7.517 10.908-7.883.092-.184.092-.55 0-.734ZM11 17.417c-4.95 0-8.158-4.95-9.075-6.417C2.75 9.533 6.05 4.583 11 4.583c4.95 0 8.158 4.95 9.075 6.417-.917 1.467-4.125 6.417-9.075 6.417Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E3D3D",
    d: "M11 7.333A3.677 3.677 0 0 0 7.333 11 3.677 3.677 0 0 0 11 14.667 3.677 3.677 0 0 0 14.667 11 3.677 3.677 0 0 0 11 7.333Zm0 5.5A1.839 1.839 0 0 1 9.167 11c0-1.008.825-1.833 1.833-1.833s1.833.825 1.833 1.833A1.839 1.839 0 0 1 11 12.833Z"
  })));
};
export default SvgElIconEye;